import { useMessageBox } from "src/Contexto/MessageBox.Context";

const MessageBoxModule = () => {
  const { ShowMessage } = useMessageBox();

  return { ShowMessage };
};

export default MessageBoxModule;
